import legalData from '@data/legal/legal.json';

const DisclaimerPage = () => {
  return (
    <div className="container-custom max-w-4xl">
      <div className="mb-8">
        <h1 className="text-3xl md:text-4xl font-bold mb-4">
          {legalData.disclaimer.title}
        </h1>
        <p className="text-sm text-gray-500">
          Last Updated: {legalData.disclaimer.lastUpdated}
        </p>
      </div>

      <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-6 mb-8">
        <h2 className="text-lg font-semibold mb-2">Important Notice</h2>
        <p className="text-gray-700">
          This website provides information services and administrative assistance only. We do not provide medical diagnosis or treatment.
          All medical services are provided by the hospitals listed. Please consult with qualified healthcare professionals for medical advice.
        </p>
      </div>

      <div className="space-y-8">
        {legalData.disclaimer.content.map((section, index) => (
          <div key={index}>
            <h2 className="text-xl font-bold mb-3">{section.heading}</h2>
            <p className="text-gray-700">{section.text}</p>
          </div>
        ))}
      </div>

      <div className="mt-12 pt-8 border-t border-gray-200">
        <h2 className="text-xl font-bold mb-4">Contact Us</h2>
        <p className="text-gray-700 mb-4">
          If you have questions about this disclaimer, please contact us through our support channels.
        </p>
        <a
          href="/"
          className="btn-primary inline-block"
        >
          Back to Home
        </a>
      </div>
    </div>
  );
};

export default DisclaimerPage;
